export const SET_NEW_VT_DASH = 'SET_NEW_VT_DASH';
export const FETCH_VT_TEMPLATES_START = 'FETCH_VT_TEMPLATES_START';
export const FETCH_VT_TEMPLATES_FULFILLED = 'FETCH_VT_TEMPLATES_FULFILLED';
export const FETCH_VT_TEMPLATES_REJECTED = 'FETCH_VT_TEMPLATES_REJECTED';

export const SET_ACTIVE_VT_DASH = 'SET_ACTIVE_VT_DASH';
export const CLEAR_ACTIVE_VT_DASH = 'CLEAR_ACTIVE_VT_DASH';

export const FETCH_EXERCISES_START = 'FETCH_EXERCISES_START';
export const FETCH_EXERCISES_FULFILLED = 'FETCH_EXERCISES_FULFILLED';
export const FETCH_EXERCISES_REJECTED = 'FETCH_EXERCISES_REJECTED';

export const FETCH_GROUPS_START = 'FETCH_GROUPS_START';
export const FETCH_GROUPS_FULFILLED = 'FETCH_GROUPS_FULFILLED';
export const FETCH_GROUPS_REJECTED = 'FETCH_GROUPS_REJECTED';

export const FETCH_VT_DASH_DATA_START = 'FETCH_VT_DASH_DATA_START';
export const FETCH_VT_DASH_DATA_FULFILLED = 'FETCH_VT_DASH_DATA_FULFILLED';
export const FETCH_VT_DASH_DATA_REJECTED = 'FETCH_VT_DASH_DATA_REJECTED';

export const SET_SELECTED_START_DATE = 'SET_SELECTED_START_DATE';
export const SET_START_DATE_DATA = 'SET_START_DATE_DATA';
export const SET_SELECTED_END_DATE = 'SET_SELECTED_END_DATE';
export const SET_END_DATE_DATA = 'SET_END_DATE_DATA';

export const SET_EXERCISES = 'SET_EXERCISES';
export const SET_BUCKET_SIZE = 'SET_BUCKET_SIZE';
export const SET_OVERVIEW_RANGE_MAX = 'SET_OVERVIEW_RANGE_MAX';
export const SET_OVERVIEW_RANGE_MIN = 'SET_OVERVIEW_RANGE_MIN';
export const SET_ASSIGNED_COMPLETED_RANGE_MAX = 'SET_ASSIGNED_COMPLETED_RANGE_MAX';
export const SET_ASSIGNED_COMPLETED_RANGE_MIN = 'SET_ASSIGNED_COMPLETED_RANGE_MIN';

export const SET_NEXT_LOCATION = 'SET_NEXT_LOCATION';
export const SET_IS_VT_DASH_DISPLAYED = 'SET_IS_VT_DASH_DISPLAYED';
export const SET_VT_DASH_VIEW = 'SET_VT_DASH_VIEW';

export const SET_GROUP = 'SET_GROUP';
export const SET_GROUPS = 'SET_GROUPS';

export const FETCH_ATHLETES_FROM_GROUP_START = 'FETCH_ATHLETES_FROM_GROUP_START';
export const FETCH_ATHLETES_FROM_GROUP_FULFILLED = 'FETCH_ATHLETES_FROM_GROUP_FULFILLED';
export const FETCH_ATHLETES_FROM_GROUP_REJECTED = 'FETCH_ATHLETES_FROM_GROUP_REJECTED';
export const SET_SELECTED_ATHLETE = 'SET_SELECTED_ATHLETE';

export const SET_IS_EXERCISE_FILTERS_SHOWING = 'SET_IS_EXERCISE_FILTERS_SHOWING';
export const SET_EXERCISE_FILTERS = 'SET_EXERCISE_FILTERS';

export const SET_UNSAVED_VT_DASH_MODAL = 'SET_UNSAVED_VT_DASH_MODAL';
export const SET_SAVE_VT_DASH_MODAL = 'SET_SAVE_VT_DASH_MODAL';

export const CREATE_VT_TEMPLATE_START = 'CREATE_VT_TEMPLATE_START';
export const CREATE_VT_TEMPLATE_FULFILLED = 'CREATE_VT_TEMPLATE_FULFILLED';
export const CREATE_VT_TEMPLATE_REJECTED = 'CREATE_VT_TEMPLATE_REJECTED';

export const SET_ABOUT_VT_DASH_MODAL = 'SET_ABOUT_VT_DASH_MODAL';

export const FETCH_PUBLIC_VT_DASH_DATA_START = 'FETCH_PUBLIC_VT_DASH_DATA_START';
export const FETCH_PUBLIC_VT_DASH_DATA_FULFILLED = 'FETCH_PUBLIC_VT_DASH_DATA_FULFILLED';
export const FETCH_PUBLIC_VT_DASH_DATA_REJECTED = 'FETCH_PUBLIC_VT_DASH_DATA_REJECTED';

export const SET_DUPLICATE_VT_DASH_MODAL = 'SET_DUPLICATE_VT_DASH_MODAL';
export const DUPLICATE_VT_TEMPLATE_START = 'DUPLICATE_VT_TEMPLATE_START';
export const DUPLICATE_VT_TEMPLATE_FULFILLED = 'DUPLICATE_VT_TEMPLATE_FULFILLED';
export const DUPLICATE_VT_TEMPLATE_REJECTED = 'DUPLICATE_VT_TEMPLATE_REJECTED';

export const SET_EDIT_VT_DASH_MODAL = 'SET_EDIT_VT_DASH_MODAL';
export const EDIT_VT_TEMPLATE_START = 'EDIT_VT_TEMPLATE_START';
export const EDIT_VT_TEMPLATE_FULFILLED = 'EDIT_VT_TEMPLATE_FULFILLED';
export const EDIT_VT_TEMPLATE_REJECTED = 'EDIT_VT_TEMPLATE_REJECTED';

export const SET_DELETE_VT_DASH_MODAL = 'SET_DELETE_VT_DASH_MODAL';
export const DELETE_VT_TEMPLATE_START = 'DELETE_VT_TEMPLATE_START';
export const DELETE_VT_TEMPLATE_FULFILLED = 'DELETE_VT_TEMPLATE_FULFILLED';
export const DELETE_VT_TEMPLATE_REJECTED = 'DELETE_VT_TEMPLATE_REJECTED';

export const SET_SHARE_VT_DASH_MODAL = 'SET_SHARE_VT_DASH_MODAL';
export const FETCH_SHARE_VT_DASH_LINK_START = 'FETCH_SHARE_VT_DASH_LINK_START';
export const FETCH_SHARE_VT_DASH_LINK_FULFILLED = 'FETCH_SHARE_VT_DASH_LINK_FULFILLED';
export const FETCH_SHARE_VT_DASH_LINK_REJECTED = 'FETCH_SHARE_VT_DASH_LINK_REJECTED';
export const CLEAR_SHARE_VT_DASH_LINK = 'CLEAR_SHARE_VT_DASH_LINK';

export const SET_OPTION_VT_DASH_MODAL = 'SET_OPTION_VT_DASH_MODAL';
export const SET_ONBOARDING_MODAL = 'SET_ONBOARDING_MODAL';

export const CLEAR_VT_DASH_DATA = 'CLEAR_VT_DASH_DATA';
export const CLEAR_VT_DASH_MODALS = 'CLEAR_VT_DASH_MODALS';
